import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const createObservationQuestion = async (payload: Partial<IAdminQuestion>) => {
	const url = "/observations/admin/questions/";
	const response = await cmsClient.post<IAdminQuestion>(url, payload);

	return response.data;
};

const useCreateObservationQuestion = () => {
	const mutation = useMutation(createObservationQuestion);
	return mutation;
};

export default useCreateObservationQuestion;
